<template>
  <div class="backdrop">
    <div class="close-btn" @click="closeBackdrop">X</div>
    <section class="backdrop-title">
      <slot name="header" />
    </section>
    <slot name="main" />
  </div>
</template>

<script>
export default {
  name: "Backdrop",

  methods: {
    closeBackdrop() {
      this.$emit("close-backdrop");
    },
  },
};
</script>

<style>
.backdrop {
  position: fixed;
  top: 50px;
  right: 0;
  bottom: 45px;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
}

.backdrop-title {
  text-align: center;
  margin-top: 60px;
}

.title {
  text-align: center;
}
.description {
  text-align: left;
}

.center {
  justify-content: center;
  display: grid;
}

.close-btn {
  position: absolute;
  right: 20px;
  cursor: pointer;
  color: white;
  font-size: 40px;
}
</style>
